import { RolodexEntryJson } from 'types'
import { GeckoEntryBase } from 'types/entries/geckoEntry'
import {
  KestrelMarkupData,
  parseKestrelMarkup,
} from 'types/kestrelViewer/kestrelMarkupParsing'
import { parseString } from 'utils/parsingHelpers'

/**
 * The markup for a Kestrel model (annotations, measurements,
 * primitives, inspection areas, plane intersections, reference planes), stored
 * as one kestrel-annotations entry per kestrel-model.
 */
export class GeckoKestrelAnnotation extends GeckoEntryBase<
  KestrelMarkupData,
  {
    'kestrel-model': string
    site?: string
    organization?: string
  }
> {
  private constructor(json: RolodexEntryJson) {
    const recordData = json.data as Record<string, unknown>
    const site = parseString(json.tags.site)
    const organization = parseString(json.tags.organization)

    super(
      json,
      parseKestrelMarkup(recordData),
      {
        'kestrel-model': parseString(json.tags['kestrel-model']) ?? '',
        ...(site ? { site } : {}),
        ...(organization ? { organization } : {}),
      },
      {}
    )
  }

  public static CreateFromJSON(json: RolodexEntryJson): GeckoKestrelAnnotation {
    return new GeckoKestrelAnnotation(json)
  }
}
